import {
  //reservation
  FOOD_TABLE_RESERVATION_LIST,
  FOOD_TABLE_RESERVATION_LIST_SUCCESS,
  FOOD_TABLE_RESERVATION_LIST_FAIL,
  FOOD_TABLE_RESERVATION_LIST_TODAY,
  FOOD_TABLE_RESERVATION_LIST_TODAY_SUCCESS,
  FOOD_TABLE_RESERVATION_LIST_TODAY_FAIL,
  FOOD_TABLE_RESERVATION_LIST_TOMORROW,
  FOOD_TABLE_RESERVATION_LIST_TOMORROW_SUCCESS,
  FOOD_TABLE_RESERVATION_LIST_TOMORROW_FAIL,
  FOOD_TABLE_RESERVATION_LIST_FUTURE,
  FOOD_TABLE_RESERVATION_LIST_FUTURE_SUCCESS,
  FOOD_TABLE_RESERVATION_LIST_FUTURE_FAIL,
  FOOD_TABLE_RESERVATION_DATA,
  FOOD_TABLE_RESERVATION_DATA_SUCCESS,
  FOOD_TABLE_RESERVATION_DATA_FAIL,
  FOOD_TABLE_RESERVATION_CREATE,
  FOOD_TABLE_RESERVATION_CREATE_SUCCESS,
  FOOD_TABLE_RESERVATION_CREATE_FAIL,
  FOOD_TABLE_RESERVATION_IMPORT,
  FOOD_TABLE_RESERVATION_IMPORT_SUCCESS,
  FOOD_TABLE_RESERVATION_IMPORT_FAIL,
  FOOD_TABLE_RESERVATION_UPDATE,
  FOOD_TABLE_RESERVATION_UPDATE_SUCCESS,
  FOOD_TABLE_RESERVATION_UPDATE_FAIL,
  FOOD_TABLE_RESERVATION_DELETE,
  FOOD_TABLE_RESERVATION_DELETE_SUCCESS,
  FOOD_TABLE_RESERVATION_DELETE_FAIL,
  //area
  FOOD_TABLE_AREA_LIST,
  FOOD_TABLE_AREA_LIST_SUCCESS,
  FOOD_TABLE_AREA_LIST_FAIL,
  FOOD_TABLE_AREA_DATA,
  FOOD_TABLE_AREA_DATA_SUCCESS,
  FOOD_TABLE_AREA_DATA_FAIL,
  FOOD_TABLE_AREA_CREATE,
  FOOD_TABLE_AREA_CREATE_SUCCESS,
  FOOD_TABLE_AREA_CREATE_FAIL,
  FOOD_TABLE_AREA_UPDATE,
  FOOD_TABLE_AREA_UPDATE_SUCCESS,
  FOOD_TABLE_AREA_UPDATE_FAIL,
  FOOD_TABLE_AREA_DELETE,
  FOOD_TABLE_AREA_DELETE_SUCCESS,
  FOOD_TABLE_AREA_DELETE_FAIL,
  //Table
  FOOD_TABLE_LIST,
  FOOD_TABLE_LIST_SUCCESS,
  FOOD_TABLE_LIST_FAIL,
  FOOD_TABLE_DATA,
  FOOD_TABLE_DATA_SUCCESS,
  FOOD_TABLE_DATA_FAIL,
  FOOD_TABLE_CREATE,
  FOOD_TABLE_CREATE_SUCCESS,
  FOOD_TABLE_CREATE_FAIL,
  FOOD_TABLE_UPDATE,
  FOOD_TABLE_UPDATE_SUCCESS,
  FOOD_TABLE_UPDATE_FAIL,
  FOOD_TABLE_DELETE,
  FOOD_TABLE_DELETE_SUCCESS,
  FOOD_TABLE_DELETE_FAIL,
  //FOOD_TABLE_RESERVATION_SEARCH
  FOOD_TABLE_RESERVATION_SEARCH,
  FOOD_TABLE_RESERVATION_SEARCH_SUCCESS,
  FOOD_TABLE_RESERVATION_SEARCH_FAIL,
  //FOOD_TABLE_BLOCK_LIST
  FOOD_TABLE_BLOCK_LIST,
  FOOD_TABLE_BLOCK_LIST_SUCCESS,
  FOOD_TABLE_BLOCK_LIST_FAIL,
  //FOOD_TABLE_BLOCK_DATA
  FOOD_TABLE_BLOCK_DATA,
  FOOD_TABLE_BLOCK_DATA_SUCCESS,
  FOOD_TABLE_BLOCK_DATA_FAIL,
  //FOOD_TABLE_BLOCK_CREATE
  FOOD_TABLE_BLOCK_CREATE,
  FOOD_TABLE_BLOCK_CREATE_SUCCESS,
  FOOD_TABLE_BLOCK_CREATE_FAIL,
  //FOOD_TABLE_DIARY_BLOCK_UPDATE
  FOOD_TABLE_DIARY_BLOCK_UPDATE,
  FOOD_TABLE_DIARY_BLOCK_UPDATE_SUCCESS,
  FOOD_TABLE_DIARY_BLOCK_UPDATE_FAIL,
  //FOOD_TABLE_BLOCK_DELETE
  FOOD_TABLE_BLOCK_DELETE,
  FOOD_TABLE_BLOCK_DELETE_SUCCESS,
  FOOD_TABLE_BLOCK_DELETE_FAIL,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_FAIL,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_FAIL,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_FAIL,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_FAIL,
  //FOOD_TABLE_DIARY_RULE_LIST
  FOOD_TABLE_DIARY_RULE_LIST,
  FOOD_TABLE_DIARY_RULE_LIST_SUCCESS,
  FOOD_TABLE_DIARY_RULE_LIST_FAIL,
  //FOOD_TABLE_DIARY_RULE_DATA
  FOOD_TABLE_DIARY_RULE_DATA,
  FOOD_TABLE_DIARY_RULE_DATA_SUCCESS,
  FOOD_TABLE_DIARY_RULE_DATA_FAIL,
  //FOOD_TABLE_DIARY_RULE_CREATE
  FOOD_TABLE_DIARY_RULE_CREATE,
  FOOD_TABLE_DIARY_RULE_CREATE_SUCCESS,
  FOOD_TABLE_DIARY_RULE_CREATE_FAIL,
  //FOOD_TABLE_DIARY_RULE_UPDATE
  FOOD_TABLE_DIARY_RULE_UPDATE,
  FOOD_TABLE_DIARY_RULE_UPDATE_SUCCESS,
  FOOD_TABLE_DIARY_RULE_UPDATE_FAIL,
  //FOOD_TABLE_DIARY_RULE_DELETE
  FOOD_TABLE_DIARY_RULE_DELETE,
  FOOD_TABLE_DIARY_RULE_DELETE_SUCCESS,
  FOOD_TABLE_DIARY_RULE_DELETE_FAIL,
  FOOD_TABLE_FLOORPLAN_SAVE,
  FOOD_TABLE_FLOORPLAN_SAVE_SUCCESS,
  FOOD_TABLE_FLOORPLAN_SAVE_FAIL,
  FOOD_TABLE_REORDER,
  FOOD_TABLE_REORDER_SUCCESS,
  FOOD_TABLE_REORDER_FAIL,
  FOOD_TABLE_DIARY_RULE_REORDER,
  FOOD_TABLE_DIARY_RULE_REORDER_SUCCESS,
  FOOD_TABLE_DIARY_RULE_REORDER_FAIL,
  //FOOD_TABLE_DIARY_RULE_SEARCH
  FOOD_TABLE_DIARY_RULE_SEARCH,
  FOOD_TABLE_DIARY_RULE_SEARCH_SUCCESS,
  FOOD_TABLE_DIARY_RULE_SEARCH_FAIL,
  //FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT
  FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT,
  FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS,
  FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_FAIL,
  //FOOD_TABLE_SEARCH
  FOOD_TABLE_SEARCH,
  FOOD_TABLE_SEARCH_SUCCESS,
  FOOD_TABLE_SEARCH_FAIL,
  FOOD_TABLE_AREA_SEARCH,
  FOOD_TABLE_AREA_SEARCH_SUCCESS,
  FOOD_TABLE_AREA_SEARCH_FAIL,
  FOOD_TABLE_RULE_SEARCH,
  FOOD_TABLE_RULE_SEARCH_SUCCESS,
  FOOD_TABLE_RULE_SEARCH_FAIL,
  //Booking Duration Rule
  FOOD_TABLE_DURATION_RULE_SEARCH,
  FOOD_TABLE_DURATION_RULE_SEARCH_SUCCESS,
  FOOD_TABLE_DURATION_RULE_SEARCH_FAIL,
  FOOD_TABLE_DURATION_RULE_DATA,
  FOOD_TABLE_DURATION_RULE_DATA_SUCCESS,
  FOOD_TABLE_DURATION_RULE_DATA_FAIL,
  FOOD_TABLE_DURATION_RULE_CREATE,
  FOOD_TABLE_DURATION_RULE_CREATE_SUCCESS,
  FOOD_TABLE_DURATION_RULE_CREATE_FAIL,
  FOOD_TABLE_DURATION_RULE_UPDATE,
  FOOD_TABLE_DURATION_RULE_UPDATE_SUCCESS,
  FOOD_TABLE_DURATION_RULE_UPDATE_FAIL,
  FOOD_TABLE_DURATION_RULE_DELETE,
  FOOD_TABLE_DURATION_RULE_DELETE_SUCCESS,
  FOOD_TABLE_DURATION_RULE_DELETE_FAIL,
  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_SUCCESS,
  FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_FAIL,
  //FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
  FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY,
  FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_SUCCESS,
  FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_FAIL,
  //FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
  FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER,
  FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_SUCCESS,
  FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_FAIL,
  // Join Tables
  //FOOD_TABLE_JOIN_LIST
  FOOD_TABLE_JOIN_LIST,
  FOOD_TABLE_JOIN_LIST_SUCCESS,
  FOOD_TABLE_JOIN_LIST_FAIL,
  //FOOD_TABLE_JOIN_DATA
  FOOD_TABLE_JOIN_DATA,
  FOOD_TABLE_JOIN_DATA_SUCCESS,
  FOOD_TABLE_JOIN_DATA_FAIL,
  //FOOD_TABLE_JOIN_CREATE
  FOOD_TABLE_JOIN_CREATE,
  FOOD_TABLE_JOIN_CREATE_SUCCESS,
  FOOD_TABLE_JOIN_CREATE_FAIL,
  //FOOD_TABLE_JOIN_DELETE
  FOOD_TABLE_JOIN_DELETE,
  FOOD_TABLE_JOIN_DELETE_SUCCESS,
  FOOD_TABLE_JOIN_DELETE_FAIL,
  //FOOD_TABLE_JOIN_SEARCH
  FOOD_TABLE_JOIN_SEARCH,
  FOOD_TABLE_JOIN_SEARCH_SUCCESS,
  FOOD_TABLE_JOIN_SEARCH_FAIL,

  //FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_FAIL,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_FAIL,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_FAIL,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_SUCCESS,
  FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_FAIL,
} from "./actionType";

const initialState = {
  foodTableReservationList: [],
  foodTableReservationListLoading: false,

  foodTableReservationListToday: [],
  foodTableReservationListTodayLoading: false,

  foodTableReservationListTomorrow: [],
  foodTableReservationListTomorrowLoading: false,

  foodTableReservationListFuture: [],
  foodTableReservationListFutureLoading: false,

  foodTableReservationData: [],
  foodTableReservationDataLoading: false,

  foodTableReservationCreate: [],
  foodTableReservationCreateLoading: false,

  foodTableReservationImport: [],
  foodTableReservationImportLoading: false,

  foodTableAreaList: [],
  foodTableAreaListLoading: false,

  foodTableAreaData: [],
  foodTableAreaDataLoading: false,

  foodTableAreaCreate: [],
  foodTableAreaCreateLoading: false,

  foodTableAreaUpdate: [],
  foodTableAreaUpdateLoading: false,

  foodTableAreaDelete: [],
  foodTableAreaDeleteLoading: false,

  foodTableList: [],
  foodTableListLoading: false,

  foodTableData: [],
  foodTableDataLoading: false,

  foodTableCreate: [],
  foodTableCreateLoading: false,

  foodTableUpdate: [],
  foodTableUpdateLoading: false,

  foodTableDelete: [],
  foodTableDeleteLoading: false,

  foodTableReservationSearch: [],
  foodTableReservationSearchLoading: false,

  foodTableReservationUpdate: [],
  foodTableReservationUpdateLoading: false,

  foodTableDiaryBlockUpdate: [],
  foodTableDiaryBlockUpdateLoading: false,

  foodTableBlockList: [],
  foodTableBlockListLoading: false,

  foodTableBlockData: [],
  foodTableBlockDataLoading: false,

  foodTableBlockCreate: [],
  foodTableBlockCreateLoading: false,

  foodTableBlockDelete: [],
  foodTableBlockDeleteLoading: false,

  foodTableReservationTableAssignmentUpdate: [],
  foodTableReservationTableAssignmentUpdateLoading: false,

  foodTableReservationTableAssignmentCancel: [],
  foodTableReservationTableAssignmentCancelLoading: false,
  // Task 24607 - Unallocated tray
  foodTableReservationTableAssignmentUnassign: [],
  foodTableReservationTableAssignmentUnassignLoading: false,
  foodTableReservationTableAssignmentAssign: [],
  foodTableReservationTableAssignmentAssignLoading: false,

  foodTableDiaryRuleList: [],
  foodTableDiaryRuleListLoading: false,

  //Booking Duration Rule
  foodTableDurationRuleSearch: [],
  foodTableDurationRuleSearchLoading: false,
  foodTableDurationRuleData: [],
  foodTableDurationRuleDataLoading: false,
  foodTableDurationRuleCreate: [],
  foodTableDurationRuleCreateLoading: false,
  foodTableDurationRuleUpdate: [],
  foodTableDurationRuleUpdateLoading: false,
  foodTableDurationRuleDelete: [],
  foodTableDurationRuleDeleteLoading: false,

  foodTableDiaryRuleData: [],
  foodTableDiaryRuleDataLoading: false,

  foodTableDiaryRuleCreate: [],
  foodTableDiaryRuleCreateLoading: false,

  foodTableDiaryRuleUpdate: [],
  foodTableDiaryRuleUpdateLoading: false,

  foodTableDiaryRuleDelete: [],
  foodTableDiaryRuleDeleteLoading: false,

  foodTableDiaryRuleReorder: [],
  foodTableDiaryRuleReorderLoading: false,

  foodTableDiaryRuleSearch: [],
  foodTableDiaryRuleSearchLoading: false,

  foodTableDiaryRuleSearchByTimeslot: [],
  foodTableDiaryRuleSearchByTimeslotLoading: false,

  //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
  foodTableReservationTableAssignmentPdfRunningOrder: [],
  foodTableReservationTableAssignmentPdfRunningOrderLoading: false,

  //FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
  foodTableReservationCheckAvailability: [],
  foodTableReservationCheckAvailabilityLoading: false,

  //FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
  foodTableReservationSearchSingleCustomer: [],
  foodTableReservationSearchSingleCustomerLoading: false,
  foodTableReservationSearchSingleCustomerError: null,
  // Join Tables
  foodTableJoinList: [],
  foodTableJoinListLoading: false,

  foodTableJoinData: [],
  foodTableJoinDataLoading: false,

  foodTableJoinCreate: [],
  foodTableJoinCreateLoading: false,

  foodTableJoinDelete: [],
  foodTableJoinDeleteLoading: false,

  foodTableJoinSearch: [],
  foodTableJoinSearchLoading: false,

  foodPreorderSiteLocationFloorPlanObjectList: [],
  foodPreorderSiteLocationFloorPlanObjectListLoading: false,

  foodPreorderSiteLocationFloorPlanObjectData: [],
  foodPreorderSiteLocationFloorPlanObjectDataLoading: false,

  foodPreorderSiteLocationFloorPlanObjectCreate: [],
  foodPreorderSiteLocationFloorPlanObjectCreateLoading: false,

  foodPreorderSiteLocationFloorPlanObjectUpdate: [],
  foodPreorderSiteLocationFloorPlanObjectUpdateLoading: false,

  foodPreorderSiteLocationFloorPlanObjectDelete: [],
  foodPreorderSiteLocationFloorPlanObjectDeleteLoading: false,
};

// Reducer
const FoodTable = (state = initialState, action) => {
  switch (action.type) {
    // Reservation cases
    case FOOD_TABLE_RESERVATION_LIST:
      return {
        ...state,
        foodTableReservationListLoading: true,
      };
    case FOOD_TABLE_RESERVATION_LIST_SUCCESS:
      return {
        ...state,
        foodTableReservationList: action.data,
        foodTableReservationListLoading: false,
      };
    case FOOD_TABLE_RESERVATION_LIST_FAIL:
      return {
        ...state,
        foodTableReservationListLoading: false,
      };

    case FOOD_TABLE_RESERVATION_LIST_TODAY:
      return {
        ...state,
        foodTableReservationListTodayLoading: true,
      };
    case FOOD_TABLE_RESERVATION_LIST_TODAY_SUCCESS:
      return {
        ...state,
        foodTableReservationListToday: action.data,
        foodTableReservationListTodayLoading: false,
      };
    case FOOD_TABLE_RESERVATION_LIST_TODAY_FAIL:
      return {
        ...state,
        foodTableReservationListTodayLoading: false,
      };

    case FOOD_TABLE_RESERVATION_LIST_TOMORROW:
      return {
        ...state,
        foodTableReservationListTomorrowLoading: true,
      };
    case FOOD_TABLE_RESERVATION_LIST_TOMORROW_SUCCESS:
      return {
        ...state,
        foodTableReservationListTomorrow: action.data,
        foodTableReservationListTomorrowLoading: false,
      };
    case FOOD_TABLE_RESERVATION_LIST_TOMORROW_FAIL:
      return {
        ...state,
        foodTableReservationListTomorrowLoading: false,
      };

    case FOOD_TABLE_RESERVATION_LIST_FUTURE:
      return {
        ...state,
        foodTableReservationListFutureLoading: true,
      };
    case FOOD_TABLE_RESERVATION_LIST_FUTURE_SUCCESS:
      return {
        ...state,
        foodTableReservationListFuture: action.data,
        foodTableReservationListFutureLoading: false,
      };
    case FOOD_TABLE_RESERVATION_LIST_FUTURE_FAIL:
      return {
        ...state,
        foodTableReservationListFutureLoading: false,
      };

    case FOOD_TABLE_RESERVATION_DATA:
      return {
        ...state,
        foodTableReservationDataLoading: true,
      };
    case FOOD_TABLE_RESERVATION_DATA_SUCCESS:
      return {
        ...state,
        foodTableReservationData: action.data,
        foodTableReservationDataLoading: false,
      };
    case FOOD_TABLE_RESERVATION_DATA_FAIL:
      return {
        ...state,
        foodTableReservationDataLoading: false,
      };
    case FOOD_TABLE_RESERVATION_CREATE:
      return {
        ...state,
        foodTableReservationCreateLoading: true,
      };
    case FOOD_TABLE_RESERVATION_CREATE_SUCCESS:
      return {
        ...state,
        foodTableReservationCreate: action.data,
        foodTableReservationCreateLoading: false,
      };
    case FOOD_TABLE_RESERVATION_CREATE_FAIL:
      return {
        ...state,
        foodTableReservationCreateLoading: false,
      };
    case FOOD_TABLE_RESERVATION_IMPORT:
      return {
        ...state,
        foodTableReservationImportLoading: true,
      };
    case FOOD_TABLE_RESERVATION_IMPORT_SUCCESS:
      return {
        ...state,
        foodTableReservationImport: action.data,
        foodTableReservationImportLoading: false,
      };
    case FOOD_TABLE_RESERVATION_IMPORT_FAIL:
      return {
        ...state,
        foodTableReservationImportLoading: false,
      };
    case FOOD_TABLE_RESERVATION_UPDATE:
      return {
        ...state,
        foodTableReservationUpdateLoading: true,
      };
    case FOOD_TABLE_RESERVATION_UPDATE_SUCCESS:
      return {
        ...state,
        foodTableReservationUpdate: action.data,
        foodTableReservationUpdateLoading: false,
      };
    case FOOD_TABLE_RESERVATION_UPDATE_FAIL:
      return {
        ...state,
        foodTableReservationUpdateLoading: false,
      };
    case FOOD_TABLE_RESERVATION_DELETE:
      return {
        ...state,
        foodTableReservationDeleteLoading: true,
      };
    case FOOD_TABLE_RESERVATION_DELETE_SUCCESS:
      return {
        ...state,
        foodTableReservationDelete: action.data,
        foodTableReservationDeleteLoading: false,
      };
    case FOOD_TABLE_RESERVATION_DELETE_FAIL:
      return {
        ...state,
        foodTableReservationDeleteLoading: false,
      };

    // Area cases
    case FOOD_TABLE_AREA_LIST:
      return {
        ...state,
        foodTableAreaListLoading: true,
      };
    case FOOD_TABLE_AREA_LIST_SUCCESS:
      return {
        ...state,
        foodTableAreaList: action.data,
        foodTableAreaListLoading: false,
      };
    case FOOD_TABLE_AREA_LIST_FAIL:
      return {
        ...state,
        foodTableAreaListLoading: false,
      };

    case FOOD_TABLE_AREA_DATA:
      return {
        ...state,
        foodTableAreaDataLoading: true,
      };
    case FOOD_TABLE_AREA_DATA_SUCCESS:
      return {
        ...state,
        foodTableAreaData: action.data,
        foodTableAreaDataLoading: false,
      };
    case FOOD_TABLE_AREA_DATA_FAIL:
      return {
        ...state,
        foodTableAreaDataLoading: false,
      };

    case FOOD_TABLE_AREA_CREATE:
      return {
        ...state,
        foodTableAreaCreateLoading: true,
      };
    case FOOD_TABLE_AREA_CREATE_SUCCESS:
      return {
        ...state,
        foodTableAreaCreate: action.data,
        foodTableAreaCreateLoading: false,
      };
    case FOOD_TABLE_AREA_CREATE_FAIL:
      return {
        ...state,
        foodTableAreaCreateLoading: false,
      };

    case FOOD_TABLE_AREA_UPDATE:
      return {
        ...state,
        foodTableAreaUpdateLoading: true,
      };
    case FOOD_TABLE_AREA_UPDATE_SUCCESS:
      return {
        ...state,
        foodTableAreaUpdate: action.data,
        foodTableAreaUpdateLoading: false,
      };
    case FOOD_TABLE_AREA_UPDATE_FAIL:
      return {
        ...state,
        foodTableAreaUpdateLoading: false,
      };

    case FOOD_TABLE_AREA_DELETE:
      return {
        ...state,
        foodTableAreaDeleteLoading: true,
      };
    case FOOD_TABLE_AREA_DELETE_SUCCESS:
      return {
        ...state,
        foodTableAreaDelete: action.data,
        foodTableAreaDeleteLoading: false,
      };
    case FOOD_TABLE_AREA_DELETE_FAIL:
      return {
        ...state,
        foodTableAreaDeleteLoading: false,
      };
    // Table cases
    case FOOD_TABLE_LIST:
      return {
        ...state,
        foodTableListLoading: true,
      };
    case FOOD_TABLE_LIST_SUCCESS:
      return {
        ...state,
        foodTableList: action.data,
        foodTableListLoading: false,
      };
    case FOOD_TABLE_LIST_FAIL:
      return {
        ...state,
        foodTableListLoading: false,
      };
    case FOOD_TABLE_DATA:
      return {
        ...state,
        foodTableDataLoading: true,
      };
    case FOOD_TABLE_DATA_SUCCESS:
      return {
        ...state,
        foodTableData: action.data,
        foodTableDataLoading: false,
      };
    case FOOD_TABLE_DATA_FAIL:
      return {
        ...state,
        foodTableDataLoading: false,
      };
    case FOOD_TABLE_CREATE:
      return {
        ...state,
        foodTableCreateLoading: true,
      };
    case FOOD_TABLE_CREATE_SUCCESS:
      return {
        ...state,
        foodTableCreate: action.data,
        foodTableCreateLoading: false,
      };
    case FOOD_TABLE_CREATE_FAIL:
      return {
        ...state,
        foodTableCreateLoading: false,
      };
    case FOOD_TABLE_UPDATE:
      return {
        ...state,
        foodTableUpdateLoading: true,
      };
    case FOOD_TABLE_UPDATE_SUCCESS:
      return {
        ...state,
        foodTableUpdate: action.data,
        foodTableUpdateLoading: false,
      };
    case FOOD_TABLE_UPDATE_FAIL:
      return {
        ...state,
        foodTableUpdateLoading: false,
      };
    case FOOD_TABLE_DELETE:
      return {
        ...state,
        foodTableDeleteLoading: true,
      };
    case FOOD_TABLE_DELETE_SUCCESS:
      return {
        ...state,
        foodTableDelete: action.data,
        foodTableDeleteLoading: false,
      };
    case FOOD_TABLE_DELETE_FAIL:
      return {
        ...state,
        foodTableDeleteLoading: false,
      };
    case FOOD_TABLE_RESERVATION_SEARCH:
      return {
        ...state,
        foodTableReservationSearchLoading: true,
      };
    case FOOD_TABLE_RESERVATION_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableReservationSearch: action.data,
        foodTableReservationSearchLoading: false,
      };
    case FOOD_TABLE_RESERVATION_SEARCH_FAIL:
      return {
        ...state,
        foodTableReservationSearchLoading: false,
      };
    case FOOD_TABLE_DIARY_BLOCK_UPDATE:
      return {
        ...state,
        foodTableDiaryBlockUpdateLoading: true,
      };
    case FOOD_TABLE_DIARY_BLOCK_UPDATE_SUCCESS:
      return {
        ...state,
        foodTableDiaryBlockUpdate: action.data,
        foodTableDiaryBlockUpdateLoading: false,
      };
    case FOOD_TABLE_DIARY_BLOCK_UPDATE_FAIL:
      return {
        ...state,
        foodTableDiaryBlockUpdateLoading: false,
      };
    case FOOD_TABLE_BLOCK_LIST:
      return {
        ...state,
        foodTableBlockListLoading: true,
      };
    case FOOD_TABLE_BLOCK_LIST_SUCCESS:
      return {
        ...state,
        foodTableBlockList: action.data,
        foodTableBlockListLoading: false,
      };
    case FOOD_TABLE_BLOCK_LIST_FAIL:
      return {
        ...state,
        foodTableBlockListLoading: false,
      };
    case FOOD_TABLE_BLOCK_DATA:
      return {
        ...state,
        foodTableBlockDataLoading: true,
      };
    case FOOD_TABLE_BLOCK_DATA_SUCCESS:
      return {
        ...state,
        foodTableBlockData: action.data,
        foodTableBlockDataLoading: false,
      };
    case FOOD_TABLE_BLOCK_DATA_FAIL:
      return {
        ...state,
        foodTableBlockDataLoading: false,
      };
    case FOOD_TABLE_BLOCK_CREATE:
      return {
        ...state,
        foodTableBlockCreateLoading: true,
      };
    case FOOD_TABLE_BLOCK_CREATE_SUCCESS:
      return {
        ...state,
        foodTableBlockCreate: action.data,
        foodTableBlockCreateLoading: false,
      };
    case FOOD_TABLE_BLOCK_CREATE_FAIL:
      return {
        ...state,
        foodTableBlockCreateLoading: false,
      };
    case FOOD_TABLE_BLOCK_DELETE:
      return {
        ...state,
        foodTableBlockDeleteLoading: true,
      };
    case FOOD_TABLE_BLOCK_DELETE_SUCCESS:
      return {
        ...state,
        foodTableBlockDelete: action.data,
        foodTableBlockDeleteLoading: false,
      };
    case FOOD_TABLE_BLOCK_DELETE_FAIL:
      return {
        ...state,
        foodTableBlockDeleteLoading: false,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE:
      return {
        ...state,
        foodTableReservationTableAssignmentUpdateLoading: true,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_SUCCESS:
      return {
        ...state,
        foodTableReservationTableAssignmentUpdate: action.data,
        foodTableReservationTableAssignmentUpdateLoading: false,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UPDATE_FAIL:
      return {
        ...state,
        foodTableReservationTableAssignmentUpdateLoading: false,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL:
      return {
        ...state,
        foodTableReservationTableAssignmentCancelLoading: true,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_SUCCESS:
      return {
        ...state,
        foodTableReservationTableAssignmentCancel: action.data,
        foodTableReservationTableAssignmentCancelLoading: false,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_CANCEL_FAIL:
      return {
        ...state,
        foodTableReservationTableAssignmentCancelLoading: false,
      };
    // Task 24607 - Unallocated tray
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN:
      return {
        ...state,
        foodTableReservationTableAssignmentUnassignLoading: true,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_SUCCESS:
      return {
        ...state,
        foodTableReservationTableAssignmentUnassign: action.data,
        foodTableReservationTableAssignmentUnassignLoading: false,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_UNASSIGN_FAIL:
      return {
        ...state,
        foodTableReservationTableAssignmentUnassignLoading: false,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN:
      return {
        ...state,
        foodTableReservationTableAssignmentAssignLoading: true,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_SUCCESS:
      return {
        ...state,
        foodTableReservationTableAssignmentAssign: action.data,
        foodTableReservationTableAssignmentAssignLoading: false,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_ASSIGN_FAIL:
      return {
        ...state,
        foodTableReservationTableAssignmentAssignLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_LIST:
      return {
        ...state,
        foodTableDiaryRuleListLoading: true,
      };
    case FOOD_TABLE_DIARY_RULE_LIST_SUCCESS:
      return {
        ...state,
        foodTableDiaryRuleList: action.data,
        foodTableDiaryRuleListLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_LIST_FAIL:
      return {
        ...state,
        foodTableDiaryRuleListLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_DATA:
      return {
        ...state,
        foodTableDiaryRuleDataLoading: true,
      };
    case FOOD_TABLE_DIARY_RULE_DATA_SUCCESS:
      return {
        ...state,
        foodTableDiaryRuleData: action.data,
        foodTableDiaryRuleDataLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_DATA_FAIL:
      return {
        ...state,
        foodTableDiaryRuleDataLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_CREATE:
      return {
        ...state,
        foodTableDiaryRuleCreateLoading: true,
      };
    case FOOD_TABLE_DIARY_RULE_CREATE_SUCCESS:
      return {
        ...state,
        foodTableDiaryRuleCreate: action.data,
        foodTableDiaryRuleCreateLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_CREATE_FAIL:
      return {
        ...state,
        foodTableDiaryRuleCreateLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_UPDATE:
      return {
        ...state,
        foodTableDiaryRuleUpdateLoading: true,
      };
    case FOOD_TABLE_DIARY_RULE_UPDATE_SUCCESS:
      return {
        ...state,
        foodTableDiaryRuleUpdate: action.data,
        foodTableDiaryRuleUpdateLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_UPDATE_FAIL:
      return {
        ...state,
        foodTableDiaryRuleUpdateLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_DELETE:
      return {
        ...state,
        foodTableDiaryRuleDeleteLoading: true,
      };
    case FOOD_TABLE_DIARY_RULE_DELETE_SUCCESS:
      return {
        ...state,
        foodTableDiaryRuleDelete: action.data,
        foodTableDiaryRuleDeleteLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_DELETE_FAIL:
      return {
        ...state,
        foodTableDiaryRuleDeleteLoading: false,
      };
    case FOOD_TABLE_REORDER:
      return {
        ...state,
        foodTableReorderLoading: true,
      };
    case FOOD_TABLE_REORDER_SUCCESS:
      return {
        ...state,
        foodTableReorder: action.data,
        foodTableReorderLoading: false,
      };
    case FOOD_TABLE_REORDER_FAIL:
      return {
        ...state,
        foodTableReorderLoading: false,
      };
    case FOOD_TABLE_FLOORPLAN_SAVE:
      return {
        ...state,
        foodTableFloorPlanSaveLoading: true,
      };
    case FOOD_TABLE_FLOORPLAN_SAVE_SUCCESS:
      return {
        ...state,
        foodTableFloorPlanSave: action.data,
        foodTableFloorPlanSaveLoading: false,
      };
    case FOOD_TABLE_FLOORPLAN_SAVE_FAIL:
      return {
        ...state,
        foodTableFloorPlanSaveLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_REORDER:
      return {
        ...state,
        foodTableDiaryRuleReorderLoading: true,
      };
    case FOOD_TABLE_DIARY_RULE_REORDER_SUCCESS:
      return {
        ...state,
        foodTableDiaryRuleReorder: action.data,
        foodTableDiaryRuleReorderLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_REORDER_FAIL:
      return {
        ...state,
        foodTableDiaryRuleReorderLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_SEARCH:
      return {
        ...state,
        foodTableDiaryRuleSearchLoading: true,
      };
    case FOOD_TABLE_DIARY_RULE_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableDiaryRuleSearch: action.data,
        foodTableDiaryRuleSearchLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_SEARCH_FAIL:
      return {
        ...state,
        foodTableDiaryRuleSearchLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT:
      return {
        ...state,
        foodTableDiaryRuleSearchByTimeslotLoading: true,
      };
    case FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_SUCCESS:
      return {
        ...state,
        foodTableDiaryRuleSearchByTimeslot: action.data,
        foodTableDiaryRuleSearchByTimeslotLoading: false,
      };
    case FOOD_TABLE_DIARY_RULE_SEARCH_BY_TIMESLOT_FAIL:
      return {
        ...state,
        foodTableDiaryRuleSearchByTimeslotLoading: false,
      };
    case FOOD_TABLE_SEARCH:
      return {
        ...state,
        foodTableSearchLoading: true,
      };
    case FOOD_TABLE_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableSearch: action.data,
        foodTableSearchLoading: false,
      };
    case FOOD_TABLE_SEARCH_FAIL:
      return {
        ...state,
        foodTableSearchLoading: false,
      };
    //Booking Duration Rule
    case FOOD_TABLE_DURATION_RULE_SEARCH:
      return {
        ...state,
        foodTableDurationRuleSearchLoading: true,
      };
    case FOOD_TABLE_DURATION_RULE_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableDurationRuleSearch: action.data,
        foodTableDurationRuleSearchLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_SEARCH_FAIL:
      return {
        ...state,
        foodTableDurationRuleSearchLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_DATA:
      return {
        ...state,
        foodTableDurationRuleDataLoading: true,
      };
    case FOOD_TABLE_DURATION_RULE_DATA_SUCCESS:
      return {
        ...state,
        foodTableDurationRuleData: action.data,
        foodTableDurationRuleDataLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_DATA_FAIL:
      return {
        ...state,
        foodTableDurationRuleDataLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_CREATE:
      return {
        ...state,
        foodTableDurationRuleCreateLoading: true,
      };
    case FOOD_TABLE_DURATION_RULE_CREATE_SUCCESS:
      return {
        ...state,
        foodTableDurationRuleCreate: action.data,
        foodTableDurationRuleCreateLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_CREATE_FAIL:
      return {
        ...state,
        foodTableDurationRuleCreateLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_UPDATE:
      return {
        ...state,
        foodTableDurationRuleUpdateLoading: true,
      };
    case FOOD_TABLE_DURATION_RULE_UPDATE_SUCCESS:
      return {
        ...state,
        foodTableDurationRuleUpdate: action.data,
        foodTableDurationRuleUpdateLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_UPDATE_FAIL:
      return {
        ...state,
        foodTableDurationRuleUpdateLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_DELETE:
      return {
        ...state,
        foodTableDurationRuleDeleteLoading: true,
      };
    case FOOD_TABLE_DURATION_RULE_DELETE_SUCCESS:
      return {
        ...state,
        foodTableDurationRuleDelete: action.data,
        foodTableDurationRuleDeleteLoading: false,
      };
    case FOOD_TABLE_DURATION_RULE_DELETE_FAIL:
      return {
        ...state,
        foodTableDurationRuleDeleteLoading: false,
      };
    case FOOD_TABLE_AREA_SEARCH:
      return {
        ...state,
        foodTableAreaSearchLoading: true,
      };
    case FOOD_TABLE_AREA_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableAreaSearch: action.data,
        foodTableAreaSearchLoading: false,
      };
    case FOOD_TABLE_AREA_SEARCH_FAIL:
      return {
        ...state,
        foodTableAreaSearchLoading: false,
      };
    case FOOD_TABLE_RULE_SEARCH:
      return {
        ...state,
        foodTableRuleSearchLoading: true,
      };
    case FOOD_TABLE_RULE_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableRuleSearch: action.data,
        foodTableRuleSearchLoading: false,
      };
    case FOOD_TABLE_RULE_SEARCH_FAIL:
      return {
        ...state,
        foodTableRuleSearchLoading: false,
      };
    //FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER:
      return {
        ...state,
        foodTableReservationTableAssignmentPdfRunningOrderLoading: true,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_SUCCESS:
      return {
        ...state,
        foodTableReservationTableAssignmentPdfRunningOrder: action.data,
        foodTableReservationTableAssignmentPdfRunningOrderLoading: false,
      };
    case FOOD_TABLE_RESERVATION_TABLE_ASSIGNMENT_PDF_RUNNING_ORDER_FAIL:
      return {
        ...state,
        foodTableReservationTableAssignmentPdfRunningOrderLoading: false,
      };
    //FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY
    case FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY:
      return {
        ...state,
        foodTableReservationCheckAvailabilityLoading: true,
      };
    case FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        foodTableReservationCheckAvailability: action.data,
        foodTableReservationCheckAvailabilityLoading: false,
      };
    case FOOD_TABLE_RESERVATION_CHECK_AVAILABILITY_FAIL:
      return {
        ...state,
        foodTableReservationCheckAvailabilityLoading: false,
      };
    //FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER
    case FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER:
      return {
        ...state,
        foodTableReservationSearchSingleCustomerLoading: true,
      };
    case FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_SUCCESS:
      return {
        ...state,
        foodTableReservationSearchSingleCustomer: action.data,
        foodTableReservationSearchSingleCustomerLoading: false,
      };
    case FOOD_TABLE_RESERVATION_SEARCH_SINGLE_CUSTOMER_FAIL:
      return {
        ...state,
        foodTableReservationSearchSingleCustomerLoading: false,
        foodTableReservationSearchSingleCustomerError: action.error,
      };
    // Join Tables
    case FOOD_TABLE_JOIN_LIST:
      return {
        ...state,
        foodTableJoinListLoading: true,
      };
    case FOOD_TABLE_JOIN_LIST_SUCCESS:
      return {
        ...state,
        foodTableJoinList: action.data,
        foodTableJoinListLoading: false,
      };
    case FOOD_TABLE_JOIN_LIST_FAIL:
      return {
        ...state,
        foodTableJoinListLoading: false,
      };
    case FOOD_TABLE_JOIN_DATA:
      return {
        ...state,
        foodTableJoinDataLoading: true,
      };
    case FOOD_TABLE_JOIN_DATA_SUCCESS:
      return {
        ...state,
        foodTableJoinData: action.data,
        foodTableJoinDataLoading: false,
      };
    case FOOD_TABLE_JOIN_DATA_FAIL:
      return {
        ...state,
        foodTableJoinDataLoading: false,
      };
    case FOOD_TABLE_JOIN_CREATE:
      return {
        ...state,
        foodTableJoinCreateLoading: true,
      };
    case FOOD_TABLE_JOIN_CREATE_SUCCESS:
      return {
        ...state,
        foodTableJoinCreate: action.data,
        foodTableJoinCreateLoading: false,
      };
    case FOOD_TABLE_JOIN_CREATE_FAIL:
      return {
        ...state,
        foodTableJoinCreateLoading: false,
      };
    case FOOD_TABLE_JOIN_DELETE:
      return {
        ...state,
        foodTableJoinDeleteLoading: true,
      };
    case FOOD_TABLE_JOIN_DELETE_SUCCESS:
      return {
        ...state,
        foodTableJoinDelete: action.data,
        foodTableJoinDeleteLoading: false,
      };
    case FOOD_TABLE_JOIN_DELETE_FAIL:
      return {
        ...state,
        foodTableJoinDeleteLoading: false,
      };
    case FOOD_TABLE_JOIN_SEARCH:
      return {
        ...state,
        foodTableJoinSearchLoading: true,
      };
    case FOOD_TABLE_JOIN_SEARCH_SUCCESS:
      return {
        ...state,
        foodTableJoinSearch: action.data,
        foodTableJoinSearchLoading: false,
      };
    case FOOD_TABLE_JOIN_SEARCH_FAIL:
      return {
        ...state,
        foodTableJoinSearchLoading: false,
      };
      //FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectListLoading: true,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_SUCCESS:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectList: action.data,
        foodPreorderSiteLocationFloorPlanObjectListLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_LIST_FAIL:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectListLoading: false,
      };
    //FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectDataLoading: true,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_SUCCESS:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectData: action.data,
        foodPreorderSiteLocationFloorPlanObjectDataLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DATA_FAIL:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectDataLoading: false,
      };
    //FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectCreateLoading: true,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_SUCCESS:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectCreate: action.data,
        foodPreorderSiteLocationFloorPlanObjectCreateLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_CREATE_FAIL:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectCreateLoading: false,
      };
    //FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectUpdateLoading: true,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_SUCCESS:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectUpdate: action.data,
        foodPreorderSiteLocationFloorPlanObjectUpdateLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_UPDATE_FAIL:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectUpdateLoading: false,
      };
    //FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectDeleteLoading: true,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_SUCCESS:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectDelete: action.data,
        foodPreorderSiteLocationFloorPlanObjectDeleteLoading: false,
      };
    case FOOD_PREORDER_SITE_LOCATION_FLOOR_PLAN_OBJECT_DELETE_FAIL:
      return {
        ...state,
        foodPreorderSiteLocationFloorPlanObjectDeleteLoading: false,
      };

    default:
      return state;
  }
};

export default FoodTable;
